import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowPathRight"><Path d="M14.6097 4.72289C13.9521 4.21703 13 4.68584 13 5.51551V8.00008H4.5C3.11929 8.00008 2 9.11937 2 10.5001V13.5001C2 14.8808 3.11929 16.0001 4.5 16.0001H13V18.4846C13 19.3143 13.9521 19.7831 14.6097 19.2773L22.0092 13.5853C23.05 12.7847 23.05 11.2154 22.0092 10.4148L14.6097 4.72289Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathRight;
